import type { MouseEventHandler } from 'react';
// mantine
import { Avatar, UnstyledButton } from '@mantine/core';
// components
import DateTime from '@/modules/DateTime/components/DateTime';
import MarkdownMessage from '@/components/MarkdownMessage';
// utils
import { DATE_FORMAT } from '@/const';
import { cn } from '@/utils';
import { getIntegrationLogo } from '@/modules/Integrations/Integrations.utils.ts';
// assets
import styles from '@/modules/Chat/components/AgentMessage/AgentMessage.module.css';

interface AgentMessageProps {
    className?: string;
    content: string | string[];
    datetime?: string;
    integrationIdn?: string | null;
    connectorIdn?: string | null;
    onDetails?: MouseEventHandler<HTMLButtonElement>;
    onReport?: MouseEventHandler<HTMLButtonElement>;
}

const AgentMessage = ({
    className,
    content,
    datetime = '',
    integrationIdn,
    connectorIdn,
    onDetails,
    onReport
}: AgentMessageProps) => {
    return (
        <div className={cn(styles.message, className)}>
            <div className={styles.messageHeader}>
                {!!(integrationIdn && connectorIdn) && (
                    <div className={styles.top}>
                        <Avatar
                            alt="vapi"
                            className="bg-white"
                            radius="xl"
                            size="xs"
                            src={getIntegrationLogo(integrationIdn)}
                        />
                        <div>{connectorIdn}</div>
                    </div>
                )}
                <div className="flex gap-[8px]">
                    {!!datetime && (
                        <div className={styles.bottom}>
                            <div className="flex items-center gap-4">
                                <UnstyledButton
                                    className="flex items-center text-[10px] text-black-6"
                                    onClick={onDetails}
                                >
                                    Show prompts
                                </UnstyledButton>
                                <UnstyledButton
                                    className="flex items-center text-[10px] text-black-6"
                                    onClick={onReport}
                                >
                                    Report
                                </UnstyledButton>
                            </div>
                        </div>
                    )}

                    {!!datetime && (
                        <div className={styles.datetime}>
                            <DateTime
                                format={DATE_FORMAT.FULL_12H_MS}
                                value={datetime}
                            />
                        </div>
                    )}
                </div>
            </div>

            {Array.isArray(content) ? (
                <div className={styles.content}>
                    {content.map((c) => (
                        <MarkdownMessage key={c}>{c}</MarkdownMessage>
                    ))}
                </div>
            ) : (
                <MarkdownMessage>{content}</MarkdownMessage>
            )}
        </div>
    );
};

export default AgentMessage;
